'use client';

export {Header, Header as default} from './default-header';
